<template>
  <AndamentoCab />
</template>

<script>
import AndamentoCab from '../components/pratiche/AndamentoCab.vue'

export default {
  components: {
    AndamentoCab,
  },
  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value,
    })
  },
}
</script>

